import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import hr from './locales/hr.json';
// PRIVREMENO: i spremljeni engleski način koristi hrvatske tekstove prema zahtjevu posla 3.
import en from './locales/en.json';

const savedLanguage = localStorage.getItem('language') || 'hr';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      hr: { translation: hr },
      en: { translation: en },
    },
    lng: savedLanguage,
    fallbackLng: 'hr',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
